import { render, staticRenderFns } from "./GuestsList.vue?vue&type=template&id=64189d9c"
import script from "./GuestsList.vue?vue&type=script&lang=js"
export * from "./GuestsList.vue?vue&type=script&lang=js"
import style0 from "./GuestsList.vue?vue&type=style&index=0&id=64189d9c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports